import { STRAPI_URL } from '../config/constants'
// Extract data from Strapi v4/v5 response
export const getStrapiData = (response) => {
    if (!response) return null;

    // Handle single item
    if (response.data && !Array.isArray(response.data)) {
        // Check if item has attributes (v4) or direct fields (v5)
        if (response.data.attributes) {
            return {
                id: response.data.id,
                documentId: response.data.documentId,
                ...response.data.attributes,
            };
        }
        // Return as-is for v5 (flat structure)
        return response.data;
    }

    // Handle collection
    if (response.data && Array.isArray(response.data)) {
        return response.data.map(item => {
            // Check if item has attributes (v4) or direct fields (v5)
            if (item.attributes) {
                return {
                    id: item.id,
                    documentId: item.documentId,
                    ...item.attributes,
                };
            }
            // Return as-is for v5 (flat structure)
            return item;
        });
    }

    return response;
};

// Extract media URL from Strapi response
// export const getMediaURL = (media, baseURL = 'http://localhost:1337') => {
//     if (!media) return null;

//     // Handle nested structure (Strapi v4)
//     const mediaData = media.data ? media.data : media;

//     // Handle array of media
//     if (Array.isArray(mediaData)) {
//         return mediaData.map(item => {
//             const url = item.attributes?.url || item.url;
//             return url?.startsWith('http') ? url : `${baseURL}${url}`;
//         });
//     }

//     // Handle single media
//     const url = mediaData.attributes?.url || mediaData.url;
//     return url?.startsWith('http') ? url : `${baseURL}${url}`;
// };






export const getMediaURL = (media, baseURL = STRAPI_URL) => {
    if (!media) return null;

    // Handle plain string URL
    if (typeof media === 'string') {
        return media.startsWith('http') ? media : `${baseURL}${media}`;
    }

    // Handle nested structure (Strapi v4)
    const mediaData = media.data ? media.data : media;

    // Handle array of media
    if (Array.isArray(mediaData)) {
        return mediaData.map(item => {
            // Handle string URLs in array
            if (typeof item === 'string') {
                return item.startsWith('http') ? item : `${baseURL}${item}`;
            }
            // Handle media objects
            const url = item.attributes?.url || item.url;
            return url?.startsWith('http') ? url : `${baseURL}${url}`;
        });
    }

    // Handle single media object
    const url = mediaData.attributes?.url || mediaData.url;
    return url?.startsWith('http') ? url : `${baseURL}${url}`;
};



// Format date
export const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

// 🔹 Convert any YouTube link to embed format
export const getEmbedUrl = (url) => {
    if (!url) return "";
    if (url.includes("watch?v=")) return url.replace("watch?v=", "embed/");
    if (url.includes("youtu.be/")) return `https://www.youtube.com/embed/${url.split("youtu.be/")[1]}`;
    return url;
};

// 🔹 Extract YouTube video ID
export const getVideoId = (url) => {
    const embedUrl = getEmbedUrl(url);
    return embedUrl.split('/embed/')[1]?.split('?')[0] || '';
};